// src/components/AssetUpload.js
import React, { useState } from 'react';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { Button, Form } from 'react-bootstrap';

const AssetUpload = () => {
  const [name, setName] = useState('');
  const [price, setPrice] = useState('');
  const [category, setCategory] = useState('');
  const [image, setImage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const db = getFirestore();
    try {
      await addDoc(collection(db, 'assets'), {
        name,
        price: parseFloat(price),
        category,
        image,
      });
      // Reset form fields
      setName('');
      setPrice('');
      setCategory('');
      setImage('');
      alert('Asset uploaded successfully!');
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="formAssetName">
        <Form.Label>Asset Name</Form.Label>
        <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} required />
      </Form.Group>
      <Form.Group controlId="formAssetPrice">
        <Form.Label>Price</Form.Label>
        <Form.Control type="number" value={price} onChange={(e) => setPrice(e.target.value)} required />
      </Form.Group>
      <Form.Group controlId="formAssetCategory">
        <Form.Label>Category</Form.Label>
        <Form.Control type="text" value={category} onChange={(e) => setCategory(e.target.value)} required />
      </Form.Group>
      <Form.Group controlId="formAssetImage">
        <Form.Label>Image URL</Form.Label>
        <Form.Control type="text" value={image} onChange={(e) => setImage(e.target.value)} required />
      </Form.Group>
      <Button variant="primary" type="submit">Upload Asset</Button>
    </Form>
  );
};

export default AssetUpload;